import { Component, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-co2-calculator-popup',
  templateUrl: './co2-calculator-popup.component.html',
  styleUrls: ['./co2-calculator-popup.component.scss'],
})
export class Co2CalculatorPopupComponent {
  constructor(public dialogRef: MatDialogRef<Co2CalculatorPopupComponent>, private ngZone: NgZone) {}

  close(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }
}
